// import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link, useHistory } from "react-router-dom";
// import Swal from "sweetalert2";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { BsPerson, BsPencilSquare, BsCheckCircleFill } from 'react-icons/bs';
// import { LuIndianRupee } from "react-icons/lu";
// import { apiRequest } from "../../apiService/allApi";
// import Rightcontainer from "../Components/Rightcontainer";

// // Keep your CSS imports
// import "../css/layout.css";
// import css from "../css/Profile.module.css";
// import "../css/kyc.css";
// import "../css/Loader.css";

// const Profile1 = ({ profile }) => {
//   // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
//   const translations = {
//     hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
//     en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
//   };

//   const { language } = useContext(LanguageContext);
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const handleClose = () => setShow1(false);
//   const handleShow = () => setShow1(true);
//   const [referral, setCode] = useState("");
//   const [Id, setId] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [portcss, setPortcss] = useState(css.active_tab);
//   const [portcss1, setPortcss1] = useState(css.inactive_tab);
//   const [holder_name, setHolder_name] = useState();
//   const [account_number, setAccount_number] = useState();
//   const [ifsc_code, setIfsc_code] = useState();
//   const [upi_id, setUpi_id] = useState();
//   const [isLoading, setIsloading] = useState(false);
//   const [showKyc, setShowKyc] = useState(false);
//   const [process1, setProcesss] = useState(false);

//   const udata = localStorage.getItem("udata");
//   const profileData = JSON.parse(udata);
//   const siteData = localStorage.getItem("sitSetting");
//   const SData = JSON.parse(siteData);

//   const handleCloseKyc = () => setShowKyc(false);
//   const handleShowKyc = () => setShowKyc(true);
//   const [inputOpen, setInputOpen] = useState(false);
//   const [Email, setEmail] = useState(null);
//   const toggleInput = () => setInputOpen(!inputOpen);
//   const history = useHistory();

//   // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
//   const logout = async () => {
//     localStorage.clear();
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await apiRequest(`me`, "GET", null, headers)
//       .then(() => { /* logic */ })
//       .catch((e) => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem("token");
//           window.location.reload();
//           history.push("/login");
//         }
//       });
//   };

//   const UpdateEmail = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Email != null) {
//       try {
//         const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
//         if (respone.data.status === false) {
//           Swal.fire({ title: respone.data.msg, icon: "error" });
//         } else {
//           setEmail(respone.data); setInputOpen(false);
//           Swal.fire({ title: respone.data.msg, icon: "success" });
//         }
//       } catch (error) { }
//     } else {
//       Swal.fire({ title: "Please enter your Email", icon: "error" });
//     }
//   };

//   const [Name, setName] = useState(null);
//   const UpdateProfile = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Name != null) {
//       const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
//       if (respone.data.status === false) {
//         Swal.fire({ title: respone.data.msg, icon: "error" });
//       } else {
//         setName(respone.data);
//         Swal.fire({ title: respone.data.msg, icon: "success" });
//       }
//     }
//   };

//   const [total, setTotal] = useState();
//   const TotalGame = async () => {
//     let access_token = localStorage.getItem("token");
//     let userId = localStorage.getItem("userId");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
//       if (res.data) setTotal(res.data);
//     } catch (e) { }
//   };

//   const Result = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const formData = new FormData();
//       formData.append("avatar", file);
//       await apiRequest(`users/me/avatar`, "POST", formData, headers);
//     }
//   };

//   const Kyc = () => setShowKyc(true);

//   const [AadharNum, setAadharNum] = useState("");
//   const [userAdharData, setUserAdharData] = useState("");
//   const handleAdharChnage = (e) => setAadharNum(e.target.value);
//   const [requestId, setRequestId] = useState(null); // New state for request_id

//   // const AdharNumber = async (e) => {
//   //   setIsloading(true); e.preventDefault();
//   //   if (/^[0-9]{12}$/.test(AadharNum)) {
//   //     const access_token = localStorage.getItem("token");
//   //     const headers = { Authorization: `Bearer ${access_token}` };
//   //     const data = { aadharNumber: AadharNum };
//   //     try {
//   //       const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//   //       setUserAdharData(res?.data);
//   //       setIsloading(false);
//   //       if (res.data.status === false) setMsg(res?.data?.msg);
//   //       else setMsg(res?.data?.data?.message);
//   //     } catch (error) { console.log(error); }
//   //   } else {
//   //     Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
//   //     setIsloading(false);
//   //   }
//   // };
//   const AdharNumber = async (e) => {
//     setIsloading(true);
//     e.preventDefault();

//     if (/^[0-9]{12}$/.test(AadharNum)) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const data = { aadharNumber: AadharNum };

//       try {
//         const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//         setIsloading(false);

//         // Yahan check karein: Agar status true hai, toh input open hona chahiye
//         if (res?.data?.status === true) {


//           setUserAdharData(res.data); // Data save ho gaya
//           setRequestId(
//             res?.data?.request_id?.data?.request_id
//           ); // request_id save karein
//           Swal.fire({ icon: "success", title: "Success", text: res.data.msg });
//           // Note: Jaise hi userAdharData set hoga, UI mein OTP input automatically dikh jayega
//         } else {
//           Swal.fire({ icon: "error", title: "Error", text: res.data.msg || "Something went wrong" });
//         }
//       } catch (error) {
//         setIsloading(false);
//         Swal.fire({ icon: "error", title: "Error", text: "Server Error" });
//       }
//     } else {
//       Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
//       setIsloading(false);
//     }
//   };
//   const [AadharOtp, setAadharOtp] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);
//   const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

//   // const AdharOtpFunc = async (e) => { // Renamed slightly to avoid collision with state
//   //   setIsloading1(true);
//   //   const access_token = localStorage.getItem("token");
//   //   const headers = { Authorization: `Bearer ${access_token}` };
//   //   const data = { aadhaarNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
//   //   try {
//   //     const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//   //     setIsloading1(false);
//   //     if (res.data.status === false) setMsg(res.data?.msg);
//   //     else window.location.reload();
//   //   } catch (e) { console.log(e); }
//   // };
//   const AdharOtpFunc = async (e) => {
//     setIsloading1(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };

//     // Yahan userAdharData.data.request_id ka use kiya gaya hai
//     const data = {
//       aadhaarNumber: AadharNum,
//       otp: AadharOtp,
//       Email: Email,
//       request_id: requestId // API response structure ke mutabik
//     };

//     try {
//       const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//       setIsloading1(false);
//       if (res.data.status === true) {
//         Swal.fire({
//           icon: "success",
//           title: "Verified",
//           text: res.data.msg,
//         });

//         setTimeout(() => {
//           window.location.reload();
//         }, 1500);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Failed",
//           text: res.data.msg,
//         });
//       }
//     } catch (e) {
//       setIsloading1(false);
//       console.error(e);
//     }
//   };
//   let aadharProcess = useRef(false);
//   const [Names, setNames] = useState("");
//   const [DOB, setDob] = useState("");
//   const [frontLoaded, setFrontLoaded] = useState(null);
//   const [backLoaded, setBackLoaded] = useState(null);

//   const handleSubmitdata = async (e) => {
//     e.preventDefault();
//     if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
//       alert("All fields required"); return;
//     }
//     if (aadharProcess.current === false) {
//       setProcesss(true); aadharProcess.current = true;
//       const formData = new FormData();
//       formData.append("Name", Names); formData.append("DOB", DOB);
//       formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
//       formData.append("Number", AadharNum); formData.append("Email", Email);
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(`aadharcard`, "POST", formData, headers);
//       if (res.data.status === false) {
//         Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
//       } else {
//         Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
//         history.push("/Profile");
//       }
//       aadharProcess.current = false; setProcesss(false);
//     }
//   };

//   useEffect(() => { TotalGame(); }, []);

//   const [isValidEmail, setIsValidEmail] = useState(true);
//   const handleEmailChange = (e) => {
//     const newEmail = e.target.value;
//     setEmail(newEmail);
//     const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
//     setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
//   };

//   const theme = localStorage.getItem('theme');
//   const styles = {
//     backgroundColor: theme === 'light' ? '#f0f2f5' : '#0f0f1b',
//     color: theme === 'light' ? '#333' : '#fff',
//   };

//   // --- NEW UI RENDERING ---
//   return (
//     <>
//       <div className="leftContainer mt-4 mb_space" style={{ ...styles, minHeight: "100vh" }}>
//         <div className="profile_page_new pt-4 px-3">

//           {/* 1. Header Card (Premium Look) */}
//           <div className="premium_card mb-4">
//             <div className="card_accent"></div>
//             <div className="d-flex align-items-center p-3">
//               <div className="avatar_container position-relative">
//                 <label style={{ cursor: 'pointer' }}>
//                   <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
//                   <img
//                     src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar5.png"}
//                     alt="User"
//                     className="main_profile_img"
//                   />
//                   <div className="camera_badge"><BsPencilSquare size={12} /></div>
//                 </label>
//               </div>
//               <div className="ms-3 flex-grow-1">
//                 {portcss === css.active_tab ? (
//                   <div className="d-flex align-items-center">
//                     <h2 className="profile_name_text mb-0">{profile?.Name || "Player"}</h2>
//                     <BsPencilSquare
//                       className="ms-2 text-warning"
//                       onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
//                       style={{ cursor: 'pointer' }}
//                     />
//                   </div>
//                 ) : (
//                   <div className="d-flex">
//                     <input
//                       type="text"
//                       className="edit_name_input"
//                       value={Name}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                     <button className="btn_save_name ms-2" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
//                       <BsCheckCircleFill />
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="kyc_badge_area">
//                 {profile?.verified === "verified" ? (
//                   <span className="badge_verified">VERIFIED</span>
//                 ) : (
//                   <span className="badge_pending" onClick={Kyc}>UNVERIFIED</span>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* 2. Stats Grid */}
//           <div className="stats_grid_premium mb-4">
//             <div className="stat_item blue_glow">
//               <img src="/images/crossswords.png" alt="" />
//               <div className="stat_text">
//                 <span className="stat_label">{translations[language].game}</span>
//                 <h3 className="stat_val">{String(total?.stringValue ?? total ?? "0")}</h3>
//               </div>
//             </div>
//             <div className="stat_item gold_glow">
//               <img src="/Coin without Glow.gif" alt="" />
//               <div className="stat_text">
//                 <span className="stat_label">{translations[language].Win}</span>
//                 <h3 className="stat_val">₹{profile?.wonAmount}</h3>
//               </div>
//             </div>
//             {/* <div className="stat_item green_glow">
//                 <img src="/images/refer1.png" alt="" />
//                 <div className="stat_text">
//                   <span className="stat_label">Referral</span>
//                   <h3 className="stat_val">₹{String(profile?.referral_earning?.stringValue ?? "0")}</h3>
//                 </div>
//              </div> */}
//             {/* <div className="stat_item purple_glow">
//                 <img src="/images/cash-withdrawal.png" alt="" />
//                 <div className="stat_text">
//                   <span className="stat_label">Withdrawal</span>
//                   <h3 className="stat_val">₹{String(profile?.totalWithdrawl?.stringValue ?? "0")}</h3>
//                 </div>
//              </div> */}
//           </div>

//           {/* 3. Account Details List */}
//           <div className="account_details_card p-3 mb-4">
//             <h4 className="section_title">General Details</h4>

//             <div className="detail_row d-flex justify-content-between align-items-center">
//               <div className="d-flex align-items-center">
//                 <div className="row_icon"><img src="/images/phone.png" width="20" /></div>
//                 <div className="row_content ms-3">
//                   <label>Phone Number</label>
//                   <p>{profile?.Phone}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="detail_row d-flex justify-content-between align-items-center">
//               <div className="d-flex align-items-center">
//                 <div className="row_icon"><img src="/images/mail.png" width="20" /></div>
//                 <div className="row_content ms-3">
//                   <label>Email ID</label>
//                   <p>{profile?.Email || "Not Updated"}</p>
//                 </div>
//               </div>
//               <BsPencilSquare className="text-primary" onClick={toggleInput} style={{ cursor: 'pointer' }} />
//             </div>

//             {inputOpen && (
//               <div className="email_update_box mt-2">
//                 <input
//                   type="email"
//                   className="modern_input"
//                   placeholder="New Email Address"
//                   value={Email}
//                   onChange={handleEmailChange}
//                 />
//                 <button className="btn_update_email mt-2 w-100" onClick={UpdateEmail}>Update Email</button>
//               </div>
//             )}

//             {/* <div className="detail_row border-0 d-flex justify-content-between align-items-center" onClick={Kyc} style={{cursor:'pointer'}}>
//                 <div className="d-flex align-items-center">
//                    <div className="row_icon"><img src="/images/kyc.png" width="20"/></div>
//                    <div className="row_content ms-3 ml-3">
//                       <label>KYC Status</label>
//                       <p className={profile?.verified === "verified" ? "text-success" : "text-warning"}>
//                         {profile?.verified === "verified" ? "Verified User" : "Complete KYC Verification"}
//                       </p>
//                    </div>
//                 </div>
//                 <div className="arrow_right">{'>'}</div>
//              </div> */}
//             <div
//               className="detail_row border-0 d-flex justify-content-between align-items-center"
//               // Clickable only if NOT verified AND NOT pending
//               onClick={
//                 profile?.verified === "verified" || profile?.verified === "pending"
//                   ? null
//                   : Kyc
//               }
//               style={{
//                 cursor:
//                   profile?.verified === "verified" || profile?.verified === "pending"
//                     ? "default"
//                     : "pointer",
//               }}
//             >
//               <div className="d-flex align-items-center">
//                 <div className="row_icon">
//                   <img src="/images/kyc.png" width="20" alt="kyc" />
//                 </div>
//                 <div className="row_content ms-3 ml-3">
//                   <label>KYC Status</label>
//                   <p
//                     className={
//                       profile?.verified === "verified"
//                         ? "text-success"
//                         : profile?.verified === "pending"
//                           ? "text-info" // Use info (blue) or primary for pending
//                           : "text-warning"
//                     }
//                   >
//                     {/* Dynamic Status Text */}
//                     {profile?.verified === "verified"
//                       ? "Verified"
//                       : profile?.verified === "pending"
//                         ? "Pending Verification"
//                         : "Complete KYC Verification"}
//                   </p>
//                 </div>
//               </div>

//               <div className="arrow_right">
//                 {/* Show arrow only if user is unverified (not verified and not pending) */}
//                 {profile?.verified === "verified" || profile?.verified === "pending"
//                   ? ""
//                   : ">"}
//               </div>
//             </div>
//           </div>

//           <div className="logout_container text-center mb-5">
//             <button className="premium_logout_btn" onClick={logout}>
//               <span>LOGOUT ACCOUNT</span>
//             </button>
//           </div>
//         </div>

//         {/* --- MODAL (Functionality Untouched, UI Cleaned) --- */}
//         <Modal show={showKyc} onHide={handleCloseKyc} centered className="dark_modal">
//           <Modal.Header closeButton className="border-0">
//             <Modal.Title style={{ color: "#000" }}>Verification Center</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="pt-0">
//             <ul className="nav nav-pills modern_tabs mb-3" id="kycTab" role="tablist">
//               {SData.onlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online</button>
//                 </li>
//               )}
//               {SData.offlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline"> Offline Kyc</button>
//                 </li>
//               )}
//             </ul>

//             <div className="tab-content mt-4">
//               {/* {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                   <div className="form-group mb-3">
//                     <label className="small text-secondary">Aadhar Number</label>
//                     <input type="number" className="modern_input" value={AadharNum} onChange={handleAdharChnage} placeholder="12 Digit Aadhar" />
//                     <p className="text-danger small mt-1">{msg}</p>
//                   </div>
//                   {isLoading ? <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" /></div> :
//                     userAdharData?.data?.status !== "SUCCESS" && <button className="btn_premium_modal w-100" onClick={AdharNumber}>Send OTP</button>
//                   }
//                   {userAdharData?.data?.status === "SUCCESS" && (
//                     <div className="mt-3">
//                       <input type="number" className="modern_input" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter OTP" />
//                       <button className="btn_premium_modal w-100 mt-2" onClick={AdharOtpFunc}>Submit OTP</button>
//                     </div>
//                   )}
//                 </div>
//               )} */}
//               {/* Online Tab */}
//               {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                   <div className="form-group mb-3">
//                     <label className="small text-secondary">Aadhar Number</label>
//                     <input
//                       type="number"
//                       className="modern_input"
//                       value={AadharNum}
//                       onChange={handleAdharChnage}
//                       placeholder="12 Digit Aadhar"
//                       disabled={userAdharData?.status === true} // OTP aane ke baad Aadhar input lock kar dein
//                     />
//                     <p className="text-info small mt-1">{msg}</p>
//                   </div>

//                   {isLoading ? (
//                     <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" /></div>
//                   ) : (
//                     // Agar status true nahi hai, tabhi "Send OTP" button dikhega
//                     userAdharData?.status !== true && (
//                       <button className="btn_premium_modal w-100" onClick={AdharNumber}>Send OTP</button>
//                     )
//                   )}

//                   {/* Yahan condition check karein: Agar status true hai to OTP input dikhayein */}
//                   {userAdharData?.status === true && (
//                     <div className="mt-3">
//                       <input
//                         type="number"
//                         className="modern_input"
//                         value={AadharOtp}
//                         onChange={handleAdharOtpChnage}
//                         placeholder="Enter OTP"
//                       />
//                       <button className="btn_premium_modal w-100 mt-2" onClick={AdharOtpFunc}>Submit OTP</button>
//                     </div>
//                   )}
//                 </div>
//               )}
//               {SData.offlineKYC && (
//                 <div className="tab-pane fade" id="offline">
//                   <input type="text" className="modern_input mb-3" placeholder="Full Name" value={Names} onChange={(e) => setNames(e.target.value)} />
//                   <input type="text" className="modern_input mb-3" placeholder="Aadhar Number" value={AadharNum} onChange={handleAdharChnage} />
//                   <input type="date" className="modern_input mb-3" value={DOB} onChange={(e) => setDob(e.target.value)} />
//                   <div className="file_upload_area mb-3">
//                     <label>Front Photo</label>
//                     <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <div className="file_upload_area mb-3">
//                     <label>Back Photo</label>
//                     <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <button className="btn_premium_modal w-100" onClick={handleSubmitdata}>Submit Verification</button>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>

//       <style dangerouslySetInnerHTML={{
//         __html: `
//         .premium_card { background: #1a1a2e; border-radius: 15px; position: relative; overflow: hidden; border: 1px solid #2a2a45; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
//         .card_accent { position: absolute; top:0; left:0; width: 100%; height: 4px; background: linear-gradient(90deg, #f39c12, #e67e22); }
//         .main_profile_img { width: 70px; height: 70px; border-radius: 50%; border: 3px solid #f39c12; object-fit: cover; }
//         .camera_badge { position: absolute; bottom: 0; right: 0; background: #f39c12; border-radius: 50%; padding: 4px; border: 2px solid #1a1a2e; }
//         .profile_name_text { font-size: 1.2rem; font-weight: 700; color: #fff; margin-left: 10px; }
//         .badge_verified { background: rgba(46, 204, 113, 0.2); color: #2ecc71; border: 1px solid #2ecc71; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; }
//         .badge_pending { background: rgba(231, 76, 60, 0.2); color: #e74c3c; border: 1px solid #e74c3c; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; cursor:pointer; }
//         .stats_grid_premium { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
//         .stat_item { background: #1a1a2e; padding: 15px; border-radius: 12px; display: flex; align-items: center; border: 1px solid #2a2a45; }
//         .stat_item img { width: 35px; height: 35px; margin-right: 12px; }
//         .stat_label { font-size: 10px; color: #888; text-transform: uppercase; display: block; }
//         .stat_val { font-size: 1.1rem; font-weight: 800; margin: 0; color: #fff; }
//         .blue_glow { border-left: 4px solid #3498db; }
//         .gold_glow { border-left: 4px solid #f1c40f; }
//         .green_glow { border-left: 4px solid #2ecc71; }
//         .purple_glow { border-left: 4px solid #9b59b6; }
//         .account_details_card { background: #000; border-radius: 15px; border: 1px solid #2a2a45; }
//         .section_title { font-size: 0.9rem; font-weight: 700; color: #f39c12; text-transform: uppercase; margin-bottom: 15px; }
//         .detail_row { padding: 12px 0; border-bottom: 1px solid #2a2a45; }
//         .row_icon { width: 40px; height: 40px; background: #252545; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
//         .row_content label { font-size: 10px; color: #888; margin:0; }
//         .row_content p { font-size: 14px; color: #fff; margin:0; font-weight: 600; }
//         .modern_input { background: #ffff; border: 1px solid #2a2a45; color: #000; padding: 10px; border-radius: 8px; width: 100%; outline: none; transition: 0.3s; }
//         .modern_input:focus { border-color: #f39c12; box-shadow: 0 0 10px rgba(243, 156, 18, 0.2); }
//         .premium_logout_btn { background: linear-gradient(90deg, #e74c3c, #c0392b); color: #fff; border: none; padding: 12px 40px; border-radius: 30px; font-weight: 800; letter-spacing: 1px; width: 80%; transition: 0.3s; }
//         .premium_logout_btn:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(231, 76, 60, 0.4); }
//         .modern_tabs .nav-link { background: #0f0f1b; color: #888; border: 1px solid #2a2a45; margin: 0 5px; font-size: 14px; font-weight: 600; }
//         .modern_tabs .nav-link.active { background: #f39c12 !important; color: #fff; border-color: #f39c12; }
//         .btn_premium_modal { background: #f39c12; color: #fff; border: none; padding: 10px; border-radius: 8px; font-weight: 700; }
//         .dark_modal .modal-content { background: #1a1a2e; color: #fff; border: 1px solid #2a2a45; border-radius: 20px; }
//         .file_upload_area { border: 2px dashed #2a2a45; padding: 10px; border-radius: 10px; text-align: center; }
//         .file_upload_area label { font-size: 12px; color: #f39c12; display: block; }
//       `}} />
//     </>
//   );
// };

// export default Profile1;


import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson, BsPencilSquare, BsCheckCircleFill, BsWallet2, BsShieldCheck } from 'react-icons/bs';
import { LuIndianRupee } from "react-icons/lu";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";

// Keep your layout and custom CSS imports
import "../css/layout.css";
import css from "../css/Profile.module.css";
import "../css/kyc.css";
import "../css/Loader.css";
// import "../css/profileNew.css"; // Separate Modern Responsive CSS

const Profile1 = ({ profile }) => {
  // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };

  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);
  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData || "{}");

  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();

  // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => { /* logic */ })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error" });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success" });
        }
      } catch (error) { }
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error" });
    }
  };

  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error" });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success" });
      }
    }
  };

  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) { }
  };

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => setAadharNum(e.target.value);
  const [requestId, setRequestId] = useState(null);

  const AdharNumber = async (e) => {
    setIsloading(true);
    e.preventDefault();

    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };

      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setIsloading(false);

        if (res?.data?.status === true) {
          setUserAdharData(res.data);
          setRequestId(res?.data?.request_id?.data?.request_id);
          Swal.fire({ icon: "success", title: "Success", text: res.data.msg });
        } else {
          Swal.fire({ icon: "error", title: "Error", text: res.data.msg || "Something went wrong" });
        }
      } catch (error) {
        setIsloading(false);
        Swal.fire({ icon: "error", title: "Error", text: "Server Error" });
      }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const data = {
      aadhaarNumber: AadharNum,
      otp: AadharOtp,
      Email: Email,
      request_id: requestId
    };

    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === true) {
        Swal.fire({
          icon: "success",
          title: "Verified",
          text: res.data.msg,
        });

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: res.data.msg,
        });
      }
    } catch (e) {
      setIsloading1(false);
    }
  };

  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  const theme = localStorage.getItem('theme');
  const styles = {
    backgroundColor: theme === 'light' ? '#f0f2f5' : '#ffffff',
    color: theme === 'light' ? '#333' : '#000',
  };

  return (
    <div className="profile-wrapper-main mt-5 pt-5 mb_space" style={{ ...styles, minHeight: "100vh" }}>
      <div className="profile-container-fluid pt-2 px-3">

        {/* 1. TOP BANNER PROFILE CARD (Matching Screenshot Exactly) */}
        <div className="custom-profile-banner">
          <div className="banner-content-row">
            <div className="avatar-upload-wrap">
              <label style={{ cursor: 'pointer', margin: 0 }}>
                <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
                <img
                  src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar6.png"}
                  alt="User"
                  className="banner-user-avatar"
                />
              </label>
            </div>

            <div className="banner-user-info">
              {portcss === css.active_tab ? (
                <div className="d-flex align-items-center">
                  <h3 className="banner-username mb-0">{profile?.Name || "pJSJt"}</h3>
                  <BsPencilSquare
                    className="ms-2 text-primary"
                    onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
                    style={{ cursor: 'pointer', fontSize: '15px' }}
                  />
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <input
                    type="text"
                    className="edit-name-inline"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Name"
                  />
                  <button className="btn-save-inline ms-1" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
                    <BsCheckCircleFill />
                  </button>
                </div>
              )}

              <div className="banner-contact-row mt-1">
                <span className="contact-icon-text">📞 {profile?.Phone || "8290971658"}</span>
              </div>

              <div className="banner-contact-row mt-1 d-flex align-items-center">
                <span className="contact-icon-text">✉️ {profile?.Email || "pJSJt@gmail.com"}</span>
                <BsPencilSquare
                  className="ms-2 text-primary"
                  onClick={toggleInput}
                  style={{ cursor: 'pointer', fontSize: '14px' }}
                />
              </div>

              {inputOpen && (
                <div className="email-edit-dropdown mt-2">
                  <input
                    type="email"
                    className="form-control form-control-sm mb-1"
                    placeholder="New Email Address"
                    value={Email}
                    onChange={handleEmailChange}
                  />
                  <button className="btn btn-primary btn-sm w-100" onClick={UpdateEmail}>Update Email</button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* 2. KYC VERIFICATION & WALLET BUTTONS BAR */}
        <div className="kyc-wallet-action-bar mb-3">
          <button className="btn-kyc-action" onClick={Kyc}>
            <span className="btn-icon-box">💳</span> KYC VERIFICATION
          </button>
          <Link to="/mywallet" className="btn-wallet-action">
            <span className="btn-icon-box">💼</span> Wallet
          </Link>
        </div>

        {/* 3. USE REFER CODE CARD */}
        <div className="refer-code-input-card mb-3">
          <label className="refer-card-label">Use Refer Code</label>
          <div className="refer-input-box-row">
            <input
              type="text"
              className="refer-code-text-input"
              placeholder="Enter Refer Code"
              value={referral}
              onChange={(e) => setCode(e.target.value)}
            />
            <span className="check-mark-icon"><BsCheckCircleFill /></span>
          </div>
        </div>

        {/* 4. OTHER DETAILS SECTION & STATS CARDS */}
        <div className="other-details-section mb-4">
          <h4 className="other-section-title">Other Details</h4>

          <div className="stats-cards-grid">
            {/* Coin Won Card */}
            <div className="custom-stat-card">
              <div className="stat-card-icon-green">💵</div>
              <div className="stat-card-content">
                <span className="stat-title-label">Coin Won</span>
                <h3 className="stat-value-num">{profile?.wonAmount || 0}</h3>
              </div>
            </div>

            {/* Battle Played Card */}
            <div className="custom-stat-card">
              <div className="stat-card-icon-dark">⚔️</div>
              <div className="stat-card-content">
                <span className="stat-title-label">Battle Played</span>
                <h3 className="stat-value-num">{String(total?.stringValue ?? total ?? "0")}</h3>
              </div>
            </div>

            {/* Referral Card */}
            <div className="custom-stat-card">
              <div className="stat-card-icon-pink">💰</div>
              <div className="stat-card-content">
                <span className="stat-title-label">Referral</span>
                <h3 className="stat-value-num">{String(profile?.referral_earning?.stringValue ?? profile?.referral_earning ?? "0")}</h3>
              </div>
            </div>
          </div>
        </div>

        {/* 5. LOG OUT BUTTON */}
        <div className="logout-button-area text-center mb-5">
          <button className="btn-custom-logout" onClick={logout}>
            Log Out
          </button>
        </div>

      </div>

      {/* --- KYC & VERIFICATION MODAL --- */}
      <Modal show={showKyc} onHide={handleCloseKyc} centered className="dark_modal">
        <Modal.Header closeButton className="border-0">
          <Modal.Title style={{ color: "#000" }}>Verification Center</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <ul className="nav nav-pills modern_tabs mb-3" id="kycTab" role="tablist">
            {SData?.onlineKYC && (
              <li className="nav-item flex-fill">
                <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online</button>
              </li>
            )}
            {SData?.offlineKYC && (
              <li className="nav-item flex-fill">
                <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline"> Offline Kyc</button>
              </li>
            )}
          </ul>

          <div className="tab-content mt-4">
            {SData?.onlineKYC && (
              <div className="tab-pane fade show active" id="online">
                <div className="form-group mb-3">
                  <label className="small text-secondary">Aadhar Number</label>
                  <input
                    type="number"
                    className="modern_input form-control"
                    value={AadharNum}
                    onChange={handleAdharChnage}
                    placeholder="12 Digit Aadhar"
                    disabled={userAdharData?.status === true}
                  />
                  <p className="text-info small mt-1">{msg}</p>
                </div>

                {isLoading ? (
                  <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" alt="loader" /></div>
                ) : (
                  userAdharData?.status !== true && (
                    <button className="btn_premium_modal w-100 btn btn-warning" onClick={AdharNumber}>Send OTP</button>
                  )
                )}

                {userAdharData?.status === true && (
                  <div className="mt-3">
                    <input
                      type="number"
                      className="modern_input form-control"
                      value={AadharOtp}
                      onChange={handleAdharOtpChnage}
                      placeholder="Enter OTP"
                    />
                    <button className="btn_premium_modal w-100 mt-2 btn btn-warning" onClick={AdharOtpFunc}>Submit OTP</button>
                  </div>
                )}
              </div>
            )}
            {SData?.offlineKYC && (
              <div className="tab-pane fade" id="offline">
                <input type="text" className="modern_input form-control mb-3" placeholder="Full Name" value={Names} onChange={(e) => setNames(e.target.value)} />
                <input type="text" className="modern_input form-control mb-3" placeholder="Aadhar Number" value={AadharNum} onChange={handleAdharChnage} />
                <input type="date" className="modern_input form-control mb-3" value={DOB} onChange={(e) => setDob(e.target.value)} />
                <div className="file_upload_area mb-3">
                  <label>Front Photo</label>
                  <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" className="form-control-file" />
                </div>
                <div className="file_upload_area mb-3">
                  <label>Back Photo</label>
                  <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" className="form-control-file" />
                </div>
                <button className="btn_premium_modal w-100 btn btn-warning" onClick={handleSubmitdata}>Submit Verification</button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <div className="rightContainer mobile-hide">
        <Rightcontainer />
      </div>
    </div>
  );
};

Profile1.defaultProps = {
  profile: {
    Name: "pJSJt",
    Phone: "00000000",
    Email: "pJSJt@gmail.com",
    verified: "unverified",
    wonAmount: 0,
    referral_earning: 0
  }
};

export default Profile1;